<template lang="pug">
  div.inner
    h2
      div.back.top(href="#",@click="backPage",:disabled="disabled()") 戻る
      | お申込みフォーム
    form#post(v-if="sets.length > 0",onsubmit="return false;")
      h3 お申込み者情報入力
      table
        tr
          th お名前
          td
            span.require 必須
          td
            ul
              li(:class="{error: msg.user_name1}")
                input(type="text",v-model="form.user_name1",name="user_name1",data-sync="send_name1",size="8",placeholder="姓",required)
              li(:class="{error: msg.user_name2}")
                input(type="text",v-model="form.user_name2",name="user_name2",data-sync="send_name2",size="8",placeholder="名",required)
            div.errorWrap
              div.error(v-if="msg.user_name1") {{ msg.user_name1[0] }}
              div.error(v-if="msg.user_name2") {{ msg.user_name2[0] }}
        tr
          th お名前（フリガナ）
          td
            span.require 必須
          td
            ul
              li(:class="{error: msg.user_kana1}")
                input(type="text",v-model="form.user_kana1",name="user_kana1",data-sync="send_kana1",size="8",placeholder="セイ",required)
              li(:class="{error: msg.user_kana2}")
                input(type="text",v-model="form.user_kana2",name="user_kana2",data-sync="send_kana2",size="8",placeholder="メイ",required)
            div.errorWrap
              div.error(v-if="msg.user_kana1") {{ msg.user_kana1[0] }}
              div.error(v-if="msg.user_kana2") {{ msg.user_kana2[0] }}
        tr
          th 電話番号
          td
            span.require 必須
          td
            ul
              li(:class="{error: msg.user_tel1}")
                input(type="text",v-model="form.user_tel1",name="user_tel1",data-sync="send_tel1",pattern="^[0-9]+$",maxlength="4",size="6",required)
              li -
              li(:class="{error: msg.user_tel2}")
                input(type="text",v-model="form.user_tel2",name="user_tel2",data-sync="send_tel2",pattern="^[0-9]+$",maxlength="4",size="6",required)
              li -
              li(:class="{error: msg.user_tel3}")
                input(type="text",v-model="form.user_tel3",name="user_tel3",data-sync="send_tel3",pattern="^[0-9]+$",maxlength="4",size="6",required)
            div.errorWrap
              div.error(v-if="msg.user_tel1") {{ msg.user_tel1[0] }}
              div.error(v-if="msg.user_tel2") {{ msg.user_tel2[0] }}
              div.error(v-if="msg.user_tel3") {{ msg.user_tel3[0] }}
        tr
          th 得意先コード・会社名
          td
          td
            ul
              li(:class="{error: msg.user_code}")
                input(type="text",v-model="form.user_code",name="user_code",size="8")
              li(:class="{error: msg.user_company}")
                input(type="text",v-model="form.user_company",name="user_company",data-sync="send_corp",size="28")
            div.errorWrap
              div.error(v-if="msg.user_code") {{ msg.user_code[0] }}
              div.error(v-if="msg.user_company") {{ msg.user_company[0] }}
        tr
          th メールアドレス
          td
            span.require 必須
          td(:class="{error: msg.user_email}")
            input(type="email",v-model="form.user_email",name="user_email",data-sync="send_email",size="28",pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$",required)
            div.error(v-if="msg.user_email") {{ msg.user_email[0] }}
        tr
          th 確認用メールアドレス
          td
            span.require 必須
          td(:class="{error: msg.user_email2}")
            input(type="email",v-model="form.user_email2",name="user_email2",data-sync="send_email2",size="28",pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$",required)
            div.error(v-if="msg.user_email2") {{ msg.user_email2[0] }}
        tr
          th 発注番号
          td
          td(:class="{error: msg.user_number}")
            input(type="text",v-model="form.user_number",name="user_number",size="28")
            div.error(v-if="msg.user_number") {{ msg.user_number[0] }}
        tr
          th 物件名
          td
            span.require 必須
          td(:class="{error: msg.user_property}")
            input(type="text",v-model="form.user_property",name="user_property",size="28",required)
            div.error(v-if="msg.user_property") {{ msg.user_property[0] }}
        tr
          th 納品希望日
          td
          td
            ul
              li(:class="{error: msg.user_year}")
                select(v-model="form.user_year",name="user_year")
                  option(v-for="n in 10",:value="user_year + n - 1") {{ user_year + n - 1 }}
              li 年
              li(:class="{error: msg.user_month}")
                select(v-model="form.user_month",name="user_month")
                  option(v-for="n in 12",:value="n") {{ n }}
              li 月
              li(:class="{error: msg.user_day}")
                select(v-model="form.user_day",name="user_day")
                  option(v-for="n in 31",:value="n") {{ n }}
              li 日
            div.errorWrap
              div.error(v-if="msg.user_year") {{ msg.user_year[0] }}
              div.error(v-if="msg.user_month") {{ msg.user_month[0] }}
              div.error(v-if="msg.user_day") {{ msg.user_day[0] }}
            p お急ぎの方は下記電話番号にお問い合わせください。<br>{{ config.tel }}<br>{{ config.time }}
      h3 お届け先情報入力
        span ※納品場所と荷受人様の情報を下記にご記入ください。

      label
        input.same(type="checkbox",@change="syncInput")
        | お申込み者情報と同じ
      table
        tr
          th お名前
          td
            span.require 必須
          td
            ul
              li(:class="{error: msg.send_name1}")
                input(type="text",v-model="form.send_name1",name="send_name1",size="8",placeholder="姓",required)
              li(:class="{error: msg.send_name2}")
                input(type="text",v-model="form.send_name2",name="send_name2",size="8",placeholder="名",required)
            div.errorWrap
              div.error(v-if="msg.send_name1") {{ msg.send_name1[0] }}
              div.error(v-if="msg.send_name2") {{ msg.send_name2[0] }}
        tr
          th お名前（フリガナ）
          td
            span.require 必須
          td
            ul
              li(:class="{error: msg.send_kana1}")
                input(type="text",v-model="form.send_kana1",name="send_kana1",size="8",placeholder="セイ",required)
              li(:class="{error: msg.send_kana2}")
                input(type="text",v-model="form.send_kana2",name="send_kana2",size="8",placeholder="メイ",required)
            div.errorWrap
              div.error(v-if="msg.send_kana1") {{ msg.send_kana1[0] }}
              div.error(v-if="msg.send_kana2") {{ msg.send_kana2[0] }}
        tr
          th 電話番号
          td
            span.require 必須
          td
            ul
              li(:class="{error: msg.send_tel1}")
                input(type="text",v-model="form.send_tel1",name="send_tel1",pattern="^[0-9]+$",maxlength="4",size="6",required)
              li -
              li(:class="{error: msg.send_tel2}")
                input(type="text",v-model="form.send_tel2",name="send_tel2",pattern="^[0-9]+$",maxlength="4",size="6",required)
              li -
              li(:class="{error: msg.send_tel3}")
                input(type="text",v-model="form.send_tel3",name="send_tel3",pattern="^[0-9]+$",maxlength="4",size="6",required)
            div.errorWrap
              div.error(v-if="msg.send_tel1") {{ msg.send_tel1[0] }}
              div.error(v-if="msg.send_tel2") {{ msg.send_tel2[0] }}
              div.error(v-if="msg.send_tel3") {{ msg.send_tel3[0] }}
        tr
          th 会社名
          td
          td(:class="{error: msg.send_corp}")
            input(type="text",v-model="form.send_corp",name="send_corp",size="28")
            div.error(v-if="msg.send_corp") {{ msg.send_corp[0] }}
        tr
          th メールアドレス
          td
          td(:class="{error: msg.send_email}")
            input(type="email",v-model="form.send_email",name="send_email",pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$",size="28")
            div.error(v-if="msg.send_email") {{ msg.send_email[0] }}
        tr
          th 確認用メールアドレス
          td
          td(:class="{error: msg.send_email2}")
            input(type="email",v-model="form.send_email2",name="send_email2",pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$",size="28")
            div.error(v-if="msg.send_email2") {{ msg.send_email2[0] }}
        tr
          th 郵便番号
          td
            span.require 必須
          td
            ul
              li(:class="{error: msg.send_zip1}")
                input(type="text",v-model="form.send_zip1",name="send_zip1",size="7",@change="yubinbango2()",maxlength="3",pattern="^[0-9]+$",required)
              li -
              li(:class="{error: msg.send_zip2}")
                input(type="text",v-model="form.send_zip2",name="send_zip2",size="7",@change="yubinbango2()",maxlength="4",pattern="^[0-9]+$",required)
            div.errorWrap
              div.error(v-if="msg.send_zip1") {{ msg.send_zip1[0] }}
              div.error(v-if="msg.send_zip2") {{ msg.send_zip2[0] }}
        tr
          th 都道府県
          td
            span.require 必須
          td(:class="{error: msg.send_pref}")
            select(v-model="form.send_pref",name="send_pref",required)
              option(v-for="n in pref",:value="n") {{ n }}
            div.error(v-if="msg.send_pref") {{ msg.send_pref[0] }}
        tr
          th 住所
          td
            span.require 必須
          td(:class="{error: msg.send_address1}")
            input(type="text",v-model="form.send_address1",name="send_address1",size="28",required)
            div.error(v-if="msg.send_address1") {{ msg.send_address1[0] }}
        tr
          th ビル・マンション名等
          td
          td(:class="{error: msg.send_address2}")
            input(type="text",v-model="form.send_address2",name="send_address2",size="28")
            div.error(v-if="msg.send_address2") {{ msg.send_address2[0] }}
        tr
          th 備考欄
          td
          td(:class="{error: msg.user_comment}")
            textarea(v-model="form.user_comment",name="user_comment",placeholder="ご要望などございましたらご記入ください。")
            div.error(v-if="msg.user_comment") {{ msg.user_comment[0] }}

      div.submit-area
        button(@click="submitCheck",:disabled="disabled()")
          | 申込み内容を確認
          img(src="@/assets/ico_arrow_right.svg")
        div.back(href="#",@click="backPage",:disabled="disabled()") 戻る
    modal(name="alert",width="450",height="200",class="alert")
      div.alert-main
        div
          p シミュレーターに戻ると入力内容が削除されます。<br>よろしいですか？
          ul
            li
              button.btnNo(@click="no") いいえ
            li
              button.btnYes(@click="yes") はい
</template>

<script>
import store from '../../stores';
import axios from 'axios';
import { Core as YubinBangoCore } from 'yubinbango-core2';
export default {
  name: 'Form',
  data () {
    return {
      msg: {},
      chk: false,
      loading: false,
      flow: 'input',
      selTime: [
        {
          tit: '午前中',
          value: '午前中'
        },
        {
          tit: '12時〜14時',
          value: '12時〜14時'
        },
        {
          tit: '14時〜16時',
          value: '14時〜16時'
        },
        {
          tit: '16時〜18時',
          value: '16時〜18時'
        },
        {
          tit: '18時〜21時',
          value: '18時〜21時'
        }
      ],
      pref: [
        '北海道',
        '青森県',
        '岩手県',
        '宮城県',
        '秋田県',
        '山形県',
        '福島県',
        '茨城県',
        '栃木県',
        '群馬県',
        '埼玉県',
        '千葉県',
        '東京都',
        '神奈川県',
        '新潟県',
        '富山県',
        '石川県',
        '福井県',
        '山梨県',
        '長野県',
        '岐阜県',
        '静岡県',
        '愛知県',
        '三重県',
        '滋賀県',
        '京都府',
        '大阪府',
        '兵庫県',
        '奈良県',
        '和歌山県',
        '鳥取県',
        '島根県',
        '岡山県',
        '広島県',
        '山口県',
        '徳島県',
        '香川県',
        '愛媛県',
        '高知県',
        '福岡県',
        '佐賀県',
        '長崎県',
        '熊本県',
        '大分県',
        '宮崎県',
        '鹿児島県',
        '沖縄県'
      ]
    };
  },
  props: {
    frm: Object
  },
  computed: {
    forms () {
      return this.$store.getters.forms;
    },
    form () {
      return this.frm;
    }
  },
  methods: {
    yubinbango: function () {
      let me = this;
      if (this.form.user_zip1 !== undefined && this.form.user_zip2 !== undefined) {
        let postalCode = this.form.user_zip1 + this.form.user_zip2;
        const s = new YubinBangoCore(postalCode, function (addr) {
          if (addr !== undefined) {
            me.form.user_pref = addr.region;
            me.form.user_address1 = addr.locality + addr.street;
            document.querySelector('[name="user_pref"]').value = me.form.user_pref;
            document.querySelector('[name="user_address1"]').value = me.form.user_address1;
          }
        });
        console.log(s);
      }
    },
    yubinbango2: function () {
      let me = this;
      if (this.form.send_zip1 !== undefined && this.form.send_zip2 !== undefined) {
        let postalCode = this.form.send_zip1 + this.form.send_zip2;
        const s = new YubinBangoCore(postalCode, function (addr) {
          if (addr !== undefined) {
            me.form.send_pref = addr.region;
            me.form.send_address1 = addr.locality + addr.street;
            document.querySelector('[name="send_pref"]').value = me.form.send_pref;
            document.querySelector('[name="send_address1"]').value = me.form.send_address1;
            me.$emit('change', me.form);
          }
        });
        console.log(s);
      }
    },
    syncInput (e) {
      let me = this;
      if (e.target.checked) {
        let elements = document.querySelectorAll('[data-sync]');
        elements.forEach(function (userItem, i) {
          let name = userItem.getAttribute('data-sync');
          let val = userItem.value;
          let it = document.querySelector('[name="' + name + '"]');
          if (it !== null) {
            it.value = val;
            me.form[name] = val;
          }
        });
        this.$emit('change', this.form);
      }
    },
    submitCheck () {
      let me = this;
      function serialize (data) {
        let obj = {};
        for (let [key, value] of data) {
          if (obj[key] !== undefined) {
            if (!Array.isArray(obj[key])) {
              obj[key] = [obj[key]];
            }
            obj[key].push(value);
          } else {
            obj[key] = value;
          }
        }
        return obj;
      }

      let form = document.querySelector('#post');
      let data = new FormData(form);
      let formObj = serialize(data);
      me.forms.form = formObj;

      // 入力チェック
      me.chk = false;
      let elements = document.querySelectorAll('[required]');
      elements.forEach(function (userItem, i) {
        if (userItem.value === '') {
          me.chk = true;
        }
      });
      let datechk = me.checkDate();
      me.msg = datechk.msg;
      // 送信
      if (!me.chk && !datechk.chk) {
        // 送信
        let url;
        url = '/api/forms?validate_only=true';
        me.loading = true;
        me.axiosConfig.headers.Authorization = 'Bearer ' + localStorage.token;
        axios.post(me.config.baseURL + url, me.forms, me.axiosConfig).then(function (response) {
          me.afterSubmit(response.data);
          me.loading = false;
        }).catch(function (error) {
          me.msg = error.response.data.message || error.message.message;
          me.loading = false;
          me.errorScroll();
        });
        // if (!me.dev) {
        // } else {
        //   axios.get('./static/api/confirm.json', me.forms, axiosConfig).then(function (response) {
        //     me.afterSubmit(response.data);
        //   });
        // }
      } else {
        if (!me.chk) {
          me.errorScroll();
        }
      }
      return false;
    },
    errorScroll () {
      document.querySelector('#main').scrollTo({
        top: 0
      });
      setTimeout(function () {
        let elements = document.querySelectorAll('.error');
        elements.forEach(function (userItem, i) {
          if (i === 0) {
            let rect = userItem.getBoundingClientRect();
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            let myTop = rect.top + scrollTop;
            document.querySelector('#main').scrollTo({
              top: myTop - 100
            });
          }
        });
      }, 200);
    },
    afterSubmit (dat) {
      if (dat.code === 'success') {
        this.$emit('confirm', this.forms.form);
      } else if (dat.code === 'error') {
      }
    },
    backPage () {
      this.$modal.show('alert');
    },
    no () {
      this.$modal.hide('alert');
    },
    yes () {
      let me = this;
      me.$modal.hide('alert');
      setTimeout(function () {
        store.commit('setFormstatus', false);
      }, 300);
    },
    backInput () {
      this.flow = 'input';
    },
    backStart () {
      this.$router.push({path: '/1'});
    },
    disabled () {
      if (this.loading) {
        return true;
      } else {
        return false;
      }
    }
  },
  created () {
    let d = new Date();
    let d2 = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 10);
    this.user_year = d2.getFullYear();
    this.form.user_year = d2.getFullYear();
    this.form.user_month = d2.getMonth() + 1;
    this.form.user_day = d2.getDate();
    this.form.user_time = '午前中';
    if (this.loginUser.user_code !== undefined && this.form.user_code === undefined) {
      this.form.user_code = this.loginUser.user_code;
    }
    if (this.loginUser.user_company !== undefined && this.form.user_company === undefined) {
      this.form.user_company = this.loginUser.user_company;
    }
  },
  mounted () {
    document.querySelector('[name="user_year"]').value = this.form.user_year;
    document.querySelector('[name="user_month"]').value = this.form.user_month;
    document.querySelector('[name="user_day"]').value = this.form.user_day;
  }
};
</script>

<style lang="stylus" scoped>
.form
  background-color #ffffff
  position fixed
  z-index 10000
  left 0
  top 0
  width 100%
  height 100%
#header
  height 77px
  border-bottom 1px solid #DDDDDD
  .inner
    max-width 1040px
    padding 0 20px
    margin 0 auto
    .logo
      padding-top 27px
#main
  position absolute
  left 0
  right 0
  top 78px
  bottom 0
  overflow auto
  .inner
    max-width 1040px
    padding 50px 20px
    margin 0 auto
  h2
    text-align center
    font-size 22px
    margin-bottom 65px
    padding 20px 0
  h3
    padding 5px 0 5px 17px
    border-left 5px solid #2E7C80
    margin-bottom 25px
    span
      font-size 14px
      font-weight normal
      display inline-block
      margin-left 60px
  table
    margin-bottom 60px
    th
      padding 8px 0
      text-align left
      font-weight normal
      vertical-align top
      &:first-child
        padding-right 20px
    td
      padding 8px 0
      vertical-align top
      span.require
        display inline-block
        color #CC0000
        padding 2px 5px
        border 1px solid #cc0000
        margin-right 20px
        font-size 12px
    ul
      display flex
      align-items center
      li
        margin-right 10px
    select
      width 90px
      background url("../../assets/ico_arrow_down.svg") no-repeat right 5px center
    label
      display inline-block
      overflow hidden
      position relative
    input[type="radio"]
      position absolute
      left -100px
    input[type="radio"] + span
      display inline-block
      width 16px
      height 16px
      border 1px solid #aaaaaa
      border-radius 50%
      vertical-align middle
      margin-top -2px
      margin-right 5px
      position relative
    input[type="radio"]:checked + span:after
      content ""
      display inline-block
      width 8px
      height 8px
      background-color #2E7C80
      border-radius 50%
      position absolute
      left 50%
      top 50%
      transform translate(-50%,-50%)
    textarea
      width 100%
      height 120px
  .submit-area
    text-align center
    /*display  flex*/
    /*justify-content center*/
    margin 0 auto 50px auto
  button,.back
    background-color #2E7C80
    font-size 20px
    font-weight bold
    color #ffffff
    border-radius 8px
    width 324px
    height 64px
    margin 0 auto 25px auto
    display flex
    justify-content center
    align-items center
    text-decoration none
    cursor pointer
    &.back
      background-color #999999
      width 120px
      &.top
        float left
        height 40px
    img
      vertical-align middle
      margin-left 10px
      display inline-block
  button[disabled="disabled"]
    background-color #999999
  .errorWrap
    .error:nth-child(n+2)
      display none
  .error
    input[type="text"]
      background-color #fff0f0
  div.error
    font-size 12px
    color #cc0000
.alert
  .vm--modal
    width 450px !important
    height 200px !important
  .alert-main
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    display flex
    justify-content center
    align-items center
  p
    margin-bottom 20px
    text-align center
    font-size 14px
  ul
    display flex
    justify-content center
    .btnNo
      width 130px !important
      height 33px !important
      border 1px solid #2E7B80 !important
      color #2E7B80 !important
      border-radius 3px !important
      background-color #ffffff !important
      font-size 12px !important
      font-weight bold !important
      margin-left 15px !important
    .btnYes
      width 130px !important
      height 33px !important
      border 1px solid #2E7B80 !important
      color #FFFFFF !important
      border-radius 3px !important
      background-color #2E7B80 !important
      font-size 12px !important
      font-weight bold !important
      margin-left 15px !important
</style>



// WEBPACK FOOTER //
// src/components/form/FormB.vue